const SIZE_TABLE_PREFIX = "SizeTable";

export const SIZE_TABLE_CLASSES = {
  table: `${SIZE_TABLE_PREFIX}-table`,
  cell: `${SIZE_TABLE_PREFIX}-cell`,
  padding: `${SIZE_TABLE_PREFIX}-padding`,
  firstCell: `${SIZE_TABLE_PREFIX}-firstCell`,
  firstColumn: `${SIZE_TABLE_PREFIX}-firstColumn`,
  head: `${SIZE_TABLE_PREFIX}-head`,
};
